import React from 'react';
import Loading from './Loading';
import Table from './Table';

import { ReactComponent as XIcon } from './images/x.svg';
import { ReactComponent as CheckIcon } from './images/check2.svg';

const Cloud = ({queue, servers}) => {

  if (queue === null || servers === null) {
    return <Loading />;
  }

  let xIcon = <XIcon className='image'
                     style={{width: '15px',
                             height: '15px',
                             fill: 'red',
                            }} />;

  let checkIcon = <CheckIcon className='image'
                             style={{width: '20px',
                                     height: '20px',
                                     fill: 'green',
                                    }} />;
  return (
    <div style={{ overflowY: 'auto',
                  padding: '20px',
                }}>
      <h2>Servers</h2>
      <Table headers={['Server', 'Ping', 'Http']}
             contents={servers.map(({ name, ping, http }) => {
               let h;
               if (http !== undefined) {
                 h = http ? checkIcon : xIcon;
               }
               else {
                 h = '';
               }
               return [name,
                       ping ? checkIcon : xIcon,
                       h];
             })}
             proportions={[1, 1, 1]} />
      <h2>Queue: </h2>
      <span style={{ color: queue > 20000 ? 'red' : 'green' }}>
        {queue}
      </span>
    </div>
  );
}

export default Cloud;
